const STICKY_CTA_MOBILE_MAX_PX = 768;

class StickyCtaBanner extends HTMLElement {
    constructor() {
        super();
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.removeScrollBar = this.removeScrollBar.bind(this);
        this.raf = null;
    }

    connectedCallback() {
        this.main = document.getElementById('MainContent');
        this.firstSection = this.resolveFirstSection();
        this.alwaysDisplayMobile = this.getAttribute('data-display-mobile') === 'true';

        this.onBeginAppClick = this.handleBeginAppClick.bind(this);
        this.querySelectorAll('.button[data-begin-app="true"]').forEach((button) => {
            button.addEventListener('click', this.handleBeginAppClick);
        });

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        window.addEventListener('freeTrialApp:quizStarted', this.removeScrollBar);

        this.updateFromScroll();
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.querySelectorAll('.button[data-begin-app="true"]').forEach((button) => {
            button.removeEventListener('click', this.onBeginAppClick);
        });
        window.removeEventListener('freeTrialApp:quizStarted', this.removeScrollBar);
        if (this.raf != null) {
            cancelAnimationFrame(this.raf);
            this.raf = null;
        }
    }

    resolveFirstSection() {
        if (!this.main) return null;
        const sections = this.main.querySelectorAll('.shopify-section');
        for (const section of sections) {
            if (section.classList.contains('section-sticky-cta-banner')) continue;
            return section;
        }
        return sections[0] || null;
    }

    onScroll() {
        if (this.raf != null) return;
        this.raf = requestAnimationFrame(() => {
            this.raf = null;
            this.updateFromScroll();
        });
    }

    onResize() {
        this.firstSection = this.resolveFirstSection();
        this.updateFromScroll();
    }

    handleBeginAppClick(e) {
        e.preventDefault();
        const button = e.currentTarget;
   
        if (button.dataset.appEvent) {

            // Allow for window state check //
            if(button.dataset.appWindowId) {
                let windowID = button.dataset.appWindowId;
                window.windowID = true;
            }
            // Send event //
            window.dispatchEvent(new CustomEvent(button.dataset.appEvent));

            // scroll and remove banner //
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }, 250);
        }
    }

    removeScrollBar() {
        // Check instance of app step button type set in customiser, if found remove banner whenever quiz start event is pinged //
        if (!this.querySelector('.button[data-begin-app="true"]')) {
            return;
        }

        // Wrapped in timeout so it isn't reomved too harshly when click from within bar //
         setTimeout(() => {
            document.querySelector('sticky-cta-banner')?.remove();
        }, 500);
    }

    updateFromScroll() {
        if (this.alwaysDisplayMobile && window.matchMedia(`(max-width: ${STICKY_CTA_MOBILE_MAX_PX}px)`).matches) {
            this.setRevealed(true);
            return;
        }

        if (!this.firstSection || !document.body.contains(this.firstSection)) {
            this.firstSection = this.resolveFirstSection();
        }

        if (!this.firstSection) {
            this.setRevealed(false);
            return;
        }

        const rect = this.firstSection.getBoundingClientRect();
        const pastFirst = rect.bottom <= 0;
        this.setRevealed(pastFirst);
    }

    setRevealed(show) {
        const isShown = this.classList.contains('sticky-cta-banner--revealed');
        if (show !== isShown) {
            this.classList.toggle('sticky-cta-banner--revealed', show);
        }
        const ariaHidden = show ? 'false' : 'true';
        if (this.getAttribute('aria-hidden') !== ariaHidden) {
            this.setAttribute('aria-hidden', ariaHidden);
        }
    }
}

customElements.define('sticky-cta-banner', StickyCtaBanner);
